module.exports = __webpack_public_path__ + "static/media/298281.0566a91e.png";